import React from "react";
import ModalShell from "./ModalShell";

export default function ConfirmDialog({
  open,
  title,
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmClassName = "btn btn-primary",
  loading = false,
  onConfirm,
  onCancel,
}) {
  if (!open) return null;

  return (
    <ModalShell
      title={title}
      subtitle="Please confirm this action before continuing."
      onClose={loading ? () => {} : onCancel}
      width={560}
    >
      <div className="confirm-dialog-text">{message}</div>

      <div className="modal-footer-actions">
        <button className="btn btn-light" onClick={onCancel} disabled={loading}>
          {cancelText}
        </button>

        <button
          className={confirmClassName}
          onClick={onConfirm}
          disabled={loading}
        >
          {loading ? "Processing..." : confirmText}
        </button>
      </div>
    </ModalShell>
  );
}
